export class PatchThingRequestItem {

  timestamp: number;

  udfs: any;

  serialNumber: string;

  group: string;

  thingTypeCode: string;

  name: string;
}



// WEBPACK FOOTER //
// ./src/models/PatchThingRequestItem.ts